<ngx-dropzone
    #drop
    [accept]="imageUpload ? 'image/jpeg,image/jpg,image/png,image/gif' : '*'"
    [multiple]="false"
    [disableClick]="true"
    [disabled]="disabled"
    (change)="onAddFiles($event)"
>
    <ngx-dropzone-label>
        @if (fileUploadPackage$ | ngrxPush) {
            <div data-cy="input-document">
                @if (fileUploadStatus$ | ngrxPush; as fileUploadStatus) {
                    @if (
                        (fileUploadStatus$ | ngrxPush) !==
                        FILE_UPLOAD_STATUS.Failed
                    ) {
                        <div class="uploader__content--progress m-2">
                            <div>
                                {{
                                    fileUploadStatus ===
                                    FILE_UPLOAD_STATUS.Started
                                        ? 'Uploading'
                                        : fileUploadStatus
                                }}
                                -
                                {{
                                    (fileUploadPackage$ | ngrxPush)?.file?.name
                                }}
                            </div>
                            <ngb-progressbar
                                [type]="$any(progressType$ | ngrxPush)"
                                [textType]="$any(progressType$ | ngrxPush)"
                                [value]="$any(fileUploadProgress$ | ngrxPush)"
                            ></ngb-progressbar>
                        </div>
                    }
                    @if (
                        (fileUploadStatus$ | ngrxPush) ===
                        FILE_UPLOAD_STATUS.Failed
                    ) {
                        <div>
                            <ng-container
                                *ngTemplateOutlet="uploadFailed"
                            ></ng-container>
                        </div>
                    }
                }
            </div>
        } @else {
            @if (rejectedFiles) {
                <ng-container *ngTemplateOutlet="uploadFailed"></ng-container>
            }
            @if (!rejectedFiles) {
                <div class="text-center body-text-medium">
                    <div>
                        {{ DRAG_AND_DROP_LABEL | translateTokenisedString }}
                    </div>
                    <div>{{ OR_LABEL | translateTokenisedString }}</div>
                </div>
                <div class="d-flex justify-content-center">
                    <wdx-icon-button
                        class="mx-1"
                        wdxStyle="outline-primary"
                        (wdxOnClick)="drop.showFileSelector()"
                        ><wdx-icon icon="file-upload"></wdx-icon
                    ></wdx-icon-button>
                </div>
            }
        }

        <ng-template #uploadFailed>
            <div class="danger-text form-section__body__blurb sub-3 mb-2">
                {{ FILE_UPLOAD_FAILED | translateTokenisedString }}
            </div>

            <div class="uploader__content--progress mb-2">
                <ngb-progressbar
                    type="danger"
                    textType="danger"
                    [value]="100"
                ></ngb-progressbar>
            </div>

            <button
                class="btn btn-ghost ms-1 me-1"
                (click)="drop.showFileSelector()"
            >
                {{ RETRY_BTN | translateTokenisedString }}
            </button>

            <button class="btn btn-ghost ms-1" (click)="onCancel()">
                {{ CANCEL_BTN | translateTokenisedString }}
            </button>
        </ng-template>
    </ngx-dropzone-label>
</ngx-dropzone>
